import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Login = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "login" */ './hocs')),
});
